var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',[_c('ui-container',[_c('ui-h1',{staticClass:"heading"},[_vm._v("Timer")]),_c('scramble-panel'),_c('cube-timer')],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }